module.exports = __webpack_public_path__ + "img/descImg1.500a546f.png";